// extracted by mini-css-extract-plugin
export default {"delete-button":"ExcursionList_delete-button__gSopD"};